'use client';

import { c as _c } from "react/compiler-runtime";
import { type BlocksContent, BlocksRenderer } from '@strapi/blocks-react-renderer';
import { FC } from 'react';
import Image from '@/components/Image';
import Link from '@/components/Link';
interface StrapiRichContentProps {
  customSchema?: Partial<any>;
  content: BlocksContent;
  isInlineContent?: boolean;
  downgradeH1ToH2?: boolean;
  // Forces every paragraph/heading block to render as this tag — for section title
  // fields where editors type plain paragraphs but the page needs a real heading.
  // The tag gets the global .rich-title class so it inherits the wrapper's typography.
  renderBlocksAsTag?: 'h2' | 'h3';
}
const StrapiRichContent: FC<StrapiRichContentProps> = t0 => {
  const $ = _c(15);
  const {
    customSchema,
    content,
    isInlineContent,
    downgradeH1ToH2,
    renderBlocksAsTag: BlockTag
  } = t0;
  if (!content) {
    return null;
  }
  let t1;
  if ($[0] !== BlockTag || $[1] !== downgradeH1ToH2 || $[2] !== isInlineContent) {
    t1 = t2 => {
      const {
        children,
        level
      } = t2;
      if (isInlineContent) {
        return children;
      }
      if (BlockTag) {
        return <BlockTag className="rich-title">{children}</BlockTag>;
      }
      const resolvedLevel = downgradeH1ToH2 && level === 1 ? 2 : level;
      if (resolvedLevel === 1) {
        return <h1>{children}</h1>;
      }
      if (resolvedLevel === 2) {
        return <h2>{children}</h2>;
      }
      if (resolvedLevel === 3) {
        return <h3>{children}</h3>;
      }
      if (resolvedLevel === 4) {
        return <h4>{children}</h4>;
      }
      if (resolvedLevel === 5) {
        return <h5>{children}</h5>;
      }
      if (resolvedLevel === 6) {
        return <h6>{children}</h6>;
      }
      return <h2>{children}</h2>;
    };
    $[0] = BlockTag;
    $[1] = downgradeH1ToH2;
    $[2] = isInlineContent;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== BlockTag || $[5] !== isInlineContent) {
    t2 = t3 => {
      const {
        children: children_1
      } = t3;
      if (isInlineContent) {
        return children_1;
      }
      if (BlockTag) {
        return <BlockTag className="rich-title">{children_1}</BlockTag>;
      }
      return <p>{children_1}</p>;
    };
    $[4] = BlockTag;
    $[5] = isInlineContent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== customSchema || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      image: _temp,
      heading: t1,
      link: _temp2,
      paragraph: t2,
      ...customSchema
    };
    $[7] = customSchema;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      strikethrough: _temp3
    };
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== content || $[13] !== t3) {
    t5 = <BlocksRenderer content={content} blocks={t3} modifiers={t4} />;
    $[12] = content;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default StrapiRichContent;
function _temp(t0) {
  const {
    image
  } = t0;
  return <Image src={image.url} width={image.width} height={image.height} alt={image.alternativeText ?? ""} />;
}
function _temp2(t0) {
  const {
    children: children_0,
    url
  } = t0;
  return <Link href={url}>{children_0}</Link>;
}
function _temp3(t0) {
  const {
    children: children_2
  } = t0;
  return <span className="rich-accent">{children_2}</span>;
}